/**
 * Controller: Edit Image Caption Modal Controller
 */
angular.module('acme.view.application.templates.create.modals.captionEditModal.controllers', [
  'ui.bootstrap'
])
.controller('EditImageCaptionModalController', [ '$scope', '$uibModalInstance', 'captionText', function ($scope, $uibModalInstance, captionText) {

  $scope.editImageCaptionModal = {

    model: {
      captionText: captionText
    },

    captionTextMax: 400,
    captionTextRemaining: 400,

    init: function () {
      if (this.model.captionText) {
        this.captionTextRemaining = this.captionTextMax - this.model.captionText.length;
      }
    },

    done: function () {
      $uibModalInstance.close(this.model.captionText);
    },

    cancel: function () {
      $uibModalInstance.dismiss();
    },

    checkForWhiteSpaces: function () {
      this.model.captionText = this.model.captionText.replace(/[\s\n]/g, ' ');
    },

    checkCaption: function () {
      if (this.model.captionText) {
        console.log('EditImageCaptionModalController::checkShortDescription', this.model.captionText.length);
        if (this.model.captionText.length > this.captionTextMax) {
          this.model.captionText = this.model.captionText.substr(0, this.captionTextMax);
        }
      } else {
        this.model.captionText = '';
      }
      this.captionTextRemaining = this.captionTextMax - this.model.captionText.length;
    }

  };

  $scope.editImageCaptionModal.init();

}]);
